/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminBookingSessionWithInstructors,
  AdminV1OrganizationsBookingSessionAssignmentsFacilityRetrieveParams,
  AdminV1OrganizationsBookingSessionAssignmentsInstructorRetrieveParams
} from '.././model';

import adminV1OrganizationsBookingSessionAssignmentsFacilityRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsBookingSessionAssignmentsInstructorRetrieveMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Group booking sessions by facility asset assignments.
 * @summary Group booking sessions by facility asset assignments.
 */
export const adminV1OrganizationsBookingSessionAssignmentsFacilityRetrieve = (
    organizationId: number,
    params: AdminV1OrganizationsBookingSessionAssignmentsFacilityRetrieveParams,
 options?: SecondParameter<typeof adminV1OrganizationsBookingSessionAssignmentsFacilityRetrieveMutator<AdminBookingSessionWithInstructors>>,) => {
      return adminV1OrganizationsBookingSessionAssignmentsFacilityRetrieveMutator<AdminBookingSessionWithInstructors>(
      {url: `/api/admin/v1/organizations/${organizationId}/booking-session-assignments/facility/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Group booking sessions by instructor assignments.
 * @summary Group booking sessions by instructor assignments.
 */
export const adminV1OrganizationsBookingSessionAssignmentsInstructorRetrieve = (
    organizationId: number,
    params: AdminV1OrganizationsBookingSessionAssignmentsInstructorRetrieveParams,
 options?: SecondParameter<typeof adminV1OrganizationsBookingSessionAssignmentsInstructorRetrieveMutator<AdminBookingSessionWithInstructors>>,) => {
      return adminV1OrganizationsBookingSessionAssignmentsInstructorRetrieveMutator<AdminBookingSessionWithInstructors>(
      {url: `/api/admin/v1/organizations/${organizationId}/booking-session-assignments/instructor/`, method: 'GET',
        params
    },
      options);
    }
  export type AdminV1OrganizationsBookingSessionAssignmentsFacilityRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBookingSessionAssignmentsFacilityRetrieve>>>
export type AdminV1OrganizationsBookingSessionAssignmentsInstructorRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsBookingSessionAssignmentsInstructorRetrieve>>>
